import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useCompliance } from "../../context/ComplianceContext";
import KanbanBoard from "../../components/common/KanbanBoard";

const ComplianceKanbanView = () => {
  const navigate = useNavigate();
  
  // 🟢 1. Destructure the exact helper function from your ComplianceContext.js
  const { compliances, updateComplianceStatus } = useCompliance(); 

  const COLUMNS = [
    { id: "Valid", title: "Valid", dotColor: "bg-emerald-500" },
    { id: "Renewal Pending", title: "Renewal Pending", dotColor: "bg-amber-500" },
    { id: "Expired", title: "Expired", dotColor: "bg-red-500" }
  ];

  // Map database statuses safely to the Kanban column IDs
  const mappedCompliances = useMemo(() => {
    return (compliances || []).map(comp => {
      const rawStatus = (comp.status || "Valid").toLowerCase();
      let kanban_status = "Valid";
      
      if (rawStatus === "renewal pending") kanban_status = "Renewal Pending";
      if (rawStatus === "expired") kanban_status = "Expired";
      
      return { ...comp, kanban_status };
    });
  }, [compliances]);

  const handleDragEnd = (result) => {
    const { destination, draggableId } = result;
    if (!destination) return;
    
    // 🟢 2. Use the exact signature your Context expects: (id, status)
    if (updateComplianceStatus) {
      updateComplianceStatus(draggableId, destination.droppableId);
    }
  };

  const renderCard = (item) => {
    const isExpired = new Date(item.expiryDate) < new Date();

    return (
      <div 
        onClick={() => navigate(`/admin/compliance-safety/edit/${item.id}`)}
        className="bg-white p-4 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition cursor-grab active:cursor-grabbing flex flex-col min-h-[130px]"
      >
        <div className="flex justify-between items-start gap-2">
          <div className="overflow-hidden">
            <h4 className="font-bold text-gray-900 text-base leading-tight truncate">
              {item.complianceName}
            </h4>
            <p className="text-[11px] text-gray-500 mt-1 truncate">
              {item.projectName || 'General'}
            </p>
          </div>
        </div>

        <div className="mt-auto pt-3 border-t border-gray-100 grid grid-cols-2 gap-3">
          <div className="overflow-hidden">
            <span className="block text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-0.5">Authority</span>
            <span className="text-xs font-bold text-gray-700 truncate block">{item.authorityName || "—"}</span>
          </div>
          <div className="overflow-hidden">
            <span className="block text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-0.5">Expiry Date</span>
            <span className={`text-xs font-bold truncate block ${isExpired ? 'text-red-600' : 'text-gray-700'}`}>
              {item.expiryDate ? new Date(item.expiryDate).toLocaleDateString() : "—"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <KanbanBoard 
      columns={COLUMNS}
      items={mappedCompliances} 
      groupBy="kanban_status"   
      onDragEnd={handleDragEnd}
      renderCard={renderCard}
    />
  );
};

export default ComplianceKanbanView;